<template>
    <Navbar :title="'订阅列表'"></Navbar>
    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="policy-file-item" v-for="record in list" :key="record" @click="goDetail(record)">
            <list-item :record="record"></list-item>
            <div class="policy-file-item-footer">
                <div>发布日期：{{ record.releaseDate }}</div>
                <div>浏览量：{{ record.releaseTime }}</div>
                <div>收藏量：{{ record.favoriteNum }}</div>
            </div>
        </div>
    </van-list>

</template>
<script>

import { getPolicyByTags,getServiceProviderList } from "@/api/home"
import Navbar from '@/components/Navbar'
import ListItem from '@/components/ListItem.vue'

import { clickUrl } from '@/utils'
import {mapState} from 'vuex'
export default {

  data() {

    return {
      list: [],
      loading: false,
      finished: false,
    }
  },
  components: { Navbar, ListItem },
  computed: {
    ...mapState({
      queryParams: state=>state.app.queryParams
    }),
  },
 
  mounted() {
    this.getData()
  },
  watch: {},
  methods: {
    
    goDetail(item){
      clickUrl('/detail',{id:item.id,policyId:item.id,title:'订阅内容',btnType:'0'})
    },
    async getData(){
      let params = this.queryParams
      let res = await getPolicyByTags()
      this.list = res.data || []
    },
  }
}
</script>
<style lang="scss">
</style>